import axiosHttp from "./interceptor";
import { emitToasterMsg } from "./toasterUtility";

export const getReportSummission = async (reportId) => {
	try {
		const response = await axiosHttp.get(
			`api/Report/GetReportSubmission?reportMstId=${reportId}`
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const CreateChildReports = async (payload) => {
	try {
		const response = await axiosHttp.post(
			`api/Report/CreateChildReport`,
			payload
		);
		return response.data;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const DeleteChildReports = (childReportID) => {
	try {
		const response = axiosHttp.get(
			`/api/Report/DeleteChildReport?reportMstId=${childReportID}`
		);
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const ReportTimeSlots = (childReportID) => {
	try {
		const response = axiosHttp.get(
			`api/Report/GetReportSlots?reportMstId=${childReportID}`
		);
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const getBdnSummaryData = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`/api/VoyageBdn/GetBdnSummery?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const getEUMRVVoyagesData = () => {
	const requestPayload = {
		entity: "MrvVoyagesDtl",
		query: {
			conditions: [
				{
					type: "and",
					queries: [
						{
							field: "IsEuVoyage",
							operation: "equals",
							value: true,
						},
					],
				},
			],
		},
		pagination: {
			page: 1,
			pageSize: 100,
		},
	};

	return axiosHttp.post(`api/query`, requestPayload);
};

export const getUKMRVVoyagesData = () => {
	const requestPayload = {
		entity: "MrvVoyagesDtl",
		query: {
			conditions: [
				{
					type: "and",
					queries: [
						{
							field: "IsUkVoyage",
							operation: "equals",
							value: true,
						},
					],
				},
			],
		},
		pagination: {
			page: 1,
			pageSize: 100,
		},
	};

	return axiosHttp.post(`api/query`, requestPayload);
};

export const getRemainingOilData = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`api/Voyages/GetVoyageRob?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		throw error;
	}
};

export const getOtherCorrectionData = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`/api/VoyageBdn/GetVoyageBdnTypeByCor?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

export const getAnnualFuelConsumptionData = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`/api/VoyageBdn/GetBdnAnnualFuelConsumption?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		emitToasterMsg("error", "Error", error.message);
	}
};

// Future Scope
export const getIMODCSData = (reportMstId) => {
	try {
		const response = axiosHttp.get(
			`/api/ImoDcs/GetImoDcs?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		// emitToasterMsg("error", "Error", error.message);
	}
};

export const getUkMrvPortStaysData = () => {
	const requestPayload = {
		entity: "MrvPortStaysDtl",
		query: {
			conditions: [
				{
					type: "and",
					queries: [
						{
							field: "IsUkPortStay",
							operation: "equals",
							value: true,
						},
					],
				},
			],
		},
		pagination: {
			page: 1,
			pageSize: 10,
		},
		includeProperties: [
			"PortName",
			"DateTimeArrival",
			"DateTimeDeparture",
			"TimeInPort",
			"HfoCons",
			"LfoCons",
			"DieselGasOilCons",
			"MdoCons",
			"MgoCons",
			"LpgbCons",
			"LpgpCons",
			"LngCons",
			"LngMnc",
			"MethanolCons",
			"EthanolCons",
			"OtherFuel1Cons",
			"OtherFuel1Mnc",
			"OtherFuel2Cons",
			"OtherFuel2Mnc",
			"OtherFuel3Cons",
			"OtherFuel3Mnc",
			"DirectCo2Measurement",
			"Description",
		],
	};
	return axiosHttp.post(`api/Query`, requestPayload);
};

export const getEuMrvPortStaysData = () => {
	const requestPayload = {
		entity: "MrvPortStaysDtl",
		query: {
			conditions: [
				{
					type: "and",
					queries: [
						{
							field: "IsEuPortStay",
							operation: "equals",
							value: true,
						},
					],
				},
			],
		},
		pagination: {
			page: 1,
			pageSize: 10,
		},
		includeProperties: [
			"PortName",
			"DateTimeArrival",
			"DateTimeDeparture",
			"TimeInPort",
			"HfoCons",
			"LfoCons",
			"DieselGasOilCons",
			"MdoCons",
			"MgoCons",
			"LpgbCons",
			"LpgpCons",
			"LngCons",
			"LngMnc",
			"MethanolCons",
			"EthanolCons",
			"OtherFuel1Cons",
			"OtherFuel1Mnc",
			"OtherFuel2Cons",
			"OtherFuel2Mnc",
			"OtherFuel3Cons",
			"OtherFuel3Mnc",
			"DirectCo2Measurement",
			"Description",
		],
	};
	return axiosHttp.post(`api/Query`, requestPayload);
};

export const getReportSummaryByType = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/Report/GetChildMrvReportEmissions?systemChildReportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		throw error;
	}
};

export const getImoDcsReportSummary = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/ImoDcs/GetDcsReportSummary2?reportMstId=${reportMstId}`
		);
		return response;
	} catch (error) {
		throw error;
	}
};

export const getReportSummeryTable = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/Report/GetChildMrvReportSummary?systemChildReportMstId=${reportMstId}`
		);

		return response;
	} catch (error) {
		throw error;
	}
};

export const getFuelEUMRVReportSummary = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/Report/GetFuelEuReportSummary?childReportId=${reportMstId}`
		);
		return response?.data;
	} catch (error) {
		throw error;
	}
};

export const getCorrectionsData = async (reportMstId) => {
	try {
		const response = await axiosHttp.get(
			`api/Corrections/GetReportCorrections?reportMstId=${reportMstId}`
		);
		if (response?.data?.data) {
			return response?.data;
		} else {
			return {};
		}
	} catch (error) {
		console.error("Error fetching corrections:", error);
		throw error;
	}
};
